// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout_container__Z6ofV {\n  min-height: 100%;\n  display: flex;\n  /*height: 100%;*/\n  margin-bottom: 5rem;\n}\n", "",{"version":3,"sources":["webpack://src/components/tank/layout-tank/layout.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".container {\n  min-height: 100%;\n  display: flex;\n  /*height: 100%;*/\n  margin-bottom: 5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "layout_container__Z6ofV"
};
export default ___CSS_LOADER_EXPORT___;
